import SSOContent from './SSOContent'

export default SSOContent
